import { routerReducer } from 'react-router-redux';
import combineReducers from './utilities/combineReducers';
import auth from './modules/auth/reducers';
import coding from './modules/coding/reducers';
import games from './modules/games/reducers';
import organizations from './modules/organizations/reducers';
import players from './modules/players/reducers';
import scores from './modules/scores/reducers';
import sessions from './modules/sessions/reducers';

const reducer = combineReducers({
  auth,
  coding,
  games,
  organizations,
  players,
  scores,
  sessions,
  routing: routerReducer,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/reducer.js